const Phone: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className ?? ''}>
      <path
        d="M16.5 1H7.5C6.12 1 5 2.12 5 3.5V20.5C5 21.88 6.12 23 7.5 23H16.5C17.88 23 19 21.88 19 20.5V3.5C19 2.12 17.88 1 16.5 1ZM12 21.125C11.378 21.125 10.875 20.622 10.875 20C10.875 19.378 11.378 18.875 12 18.875C12.622 18.875 13.125 19.378 13.125 20C13.125 20.622 12.622 21.125 12 21.125ZM17 18H7V4H17V18Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Phone;
